export default "__VITE_ASSET__DqZjO8Aj__"